import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEntry = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M120-240q-17 0-28.5-11.5T80-280v-400q0-17 11.5-28.5T120-720q17 0 28.5 11.5T160-680v400q0 17-11.5 28.5T120-240Zm607-200H280q-17 0-28.5-11.5T240-480q0-17 11.5-28.5T280-520h447L612-636q-11-11-11.5-27.5T612-692q11-11 28-11t28 11l184 184q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L668-268q-11 11-27.5 11T612-268q-12-12-12-28.5t12-28.5l115-115Z" })
});
export default SvgEntry;
